import { useParams, Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';
import PageSEO from '@/components/base/PageSEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="pt-20 pb-14 text-center">
          <h1 className="text-2xl font-heading font-bold text-foreground-900">分类不存在</h1>
          <Link to="/" className="text-primary-500 mt-4 inline-block">返回首页</Link>
        </div>
        <Footer />
      </>
    );
  }

  const categoryArticles = articles.filter((a) => a.categorySlug === slug);

  const collectionSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 911吃瓜网`,
    description: `911吃瓜网${category.name}频道，${category.description}。每日实时追踪最新${category.name}内容，独家爆料不断更新。`,
    url: `http://51cgwang.cn/category/${slug}`,
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: categoryArticles.slice(0, 20).map((article, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Article',
          name: article.title,
          url: `http://51cgwang.cn/article/${article.id}`,
          description: article.summary,
          datePublished: article.publishDate,
        },
      })),
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://51cgwang.cn/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: category.name,
      },
    ],
  };

  return (
    <>
      <PageSEO
        title={`${category.name} - 911吃瓜网 | 网红黑料实时追踪`}
        description={`911吃瓜网${category.name}频道，${category.description}。每日实时追踪最新${category.name}内容，独家爆料不断更新。`}
        keywords={`911吃瓜网,${category.name},网红黑料,实时爆料,吃瓜爆料`}
        canonicalUrl={`http://51cgwang.cn/category/${slug}`}
      />
      <script type="application/ld+json">
        {JSON.stringify(collectionSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
      <Navbar />

      <main>
        <section className="relative w-full h-[280px] md:h-[380px] overflow-hidden">
          <div className="absolute inset-0 mx-4 md:mx-6 my-3 md:my-4 rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20background%20with%20warm%20red%20and%20dark%20tones%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%2C%20editorial%20style%2C%20rich%20contrast%2C%20professional%20lighting%2C%20bold%20dramatic%20mood%2C%20minimal%20composition&width=1600&height=800&seq=category-hero-generic&orientation=landscape"
              alt={`911吃瓜网 - ${category.name}`}
              title={`${category.name} - 911吃瓜网`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/25 to-black/55"></div>
          </div>
          <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 w-full">
            <span className="inline-block px-4 py-1.5 border border-white/40 text-white text-sm rounded-full mb-4 backdrop-blur-sm whitespace-nowrap">
              分类浏览
            </span>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-3">
              {category.name}
            </h1>
            <p className="text-sm text-white/70 max-w-md">
              {category.description}
            </p>
          </div>
        </section>

        <section className="py-10 px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb
              items={[
                { name: '首页', path: '/' },
                { name: category.name },
              ]}
            />

            <div className="flex flex-wrap gap-2 mb-8">
              <span className="px-3 py-1.5 bg-background-100 text-foreground-600 text-xs rounded-full cursor-pointer hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap">
                全部
              </span>
              <span className="px-3 py-1.5 bg-background-100 text-foreground-600 text-xs rounded-full cursor-pointer hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap">
                最新发布
              </span>
              <span className="px-3 py-1.5 bg-background-100 text-foreground-600 text-xs rounded-full cursor-pointer hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap">
                最多阅读
              </span>
              <span className="px-3 py-1.5 bg-primary-50 text-primary-600 text-xs rounded-full cursor-pointer whitespace-nowrap">
                独家爆料
              </span>
            </div>

            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg font-heading font-bold text-foreground-900">
                最新{category.name}
              </h2>
              <span className="text-xs text-foreground-400">
                共 {categoryArticles.length} 篇
              </span>
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">暂无相关内容，敬请期待</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}